(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');


      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollLocked = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('hashchange', this.onScrollHandler);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('hashchange', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        // If header is already off-screen (e.g. page reload mid-scroll),
        // use the header's rect offset by scroll position as bounds
        if (!this.headerBounds.height && this.header) {
          const rect = this.header.getBoundingClientRect();
          this.headerBounds = {
            top: rect.top + window.scrollY,
            bottom: rect.bottom + window.scrollY,
            height: rect.height,
          };
        }
        observer.disconnect();
        // Check initial scroll state after bounds are set
        this.onScroll();
      });

      observer.observe(this.header);
    }

    lockScroll() {
      this.scrollLocked = true;
    }

    unlockScroll() {
      this.scrollLocked = false;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.scrollLocked) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.querySelector('details-modal[open], header-drawer details[open]')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top - this.getStickyOffset()) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-hidden')) return;
      this.closeMenuDisclosure();
      this.closeSearchModal();
      // Frame 1: position in sticky state
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('animate');
      // Frame 2: enable transition, force reflow, then trigger transform
      requestAnimationFrame(() => {
        this.header.classList.add('animate');
        this.header.offsetHeight; // force reflow so browser registers the "from" state
        this.header.classList.add('shopify-section-header-hidden');
        window.dispatchEvent(new CustomEvent('header:hide', { detail: { top: 0 } }));
      });
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      const top = this.getAnnouncementBarHeight() + this.getHeaderHeight() - 1;

      window.dispatchEvent(new CustomEvent('header:reveal', { detail: { top } }));
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      window.dispatchEvent(new CustomEvent('header:reset', { detail: { top: 0 } }));
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }

    getAnnouncementBarHeight() {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height');
      const height = parseFloat(value);
      return Number.isNaN(height) ? 0 : height;
    }

    getHeaderHeight() {
      return this.header.offsetHeight;
    }

    getStickyOffset() {
      return this.isDesktop()
        ? this.getAnnouncementBarHeight() + this.getPromotionTimerHeight()
        : 0;
    }

    isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    getPromotionTimerHeight() {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--promotion-timer-mobile-height');
      const height = parseFloat(value);
      return Number.isNaN(height) ? 0 : height;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-announcement-bar"] && !Shopify.designMode) return;
  try {
    

  // Announcement bar is not sticky on any viewport — no-op custom element
  class StickyAnnouncementBar extends HTMLElement {}

  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-promotion-timer-mb"] && !Shopify.designMode) return;
  try {
    
  class StickyPromotionTimer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionWrapper = this.closest('.section-promotion-timer-mobile') || this;
      this.desktopMQ = window.matchMedia('(min-width: 990px)');

      this.onHeaderHideHandler = this.onHeaderHide.bind(this);
      this.onHeaderRevealHandler = this.onHeaderReveal.bind(this);
      this.onHeaderResetHandler = this.onHeaderReset.bind(this);

      window.addEventListener('header:hide', this.onHeaderHideHandler);
      window.addEventListener('header:reveal', this.onHeaderRevealHandler);
      window.addEventListener('header:reset', this.onHeaderResetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('header:hide', this.onHeaderHideHandler);
      window.removeEventListener('header:reveal', this.onHeaderRevealHandler);
      window.removeEventListener('header:reset', this.onHeaderResetHandler);
    }

    // Hide instantly — no animation to avoid static→fixed jump
    onHeaderHide(event) {
      if (!this.sectionWrapper || this.desktopMQ.matches) return;
      this.sectionWrapper.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.sectionWrapper.classList.remove('animate');
    }

    onHeaderReveal(event) {
      if (!this.sectionWrapper || this.desktopMQ.matches) return;
      this.sectionWrapper.classList.add('shopify-section-header-sticky', 'animate');
      this.sectionWrapper.classList.remove('shopify-section-header-hidden');
    }

    onHeaderReset(event) {
      if (!this.sectionWrapper || this.desktopMQ.matches) return;
      this.sectionWrapper.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  customElements.define('sticky-promotion-timer', StickyPromotionTimer);

  } catch(e) { console.error(e); }
})();
})();
